import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionQuotationPage_Quotation_Foapu_Mutation = graphql(`
  mutation MissionQuotationPage_Quotation_Foapu(
    $filter: IdFilterInput!
    $update: QuotationPartialInput!
    $versionData: VersionDataInput
  ) {
    findOneAndPartialUpdateQuotation(
      filter: $filter
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type MissionQuotation_Foapu_Result = ResultOf<
  typeof MissionQuotationPage_Quotation_Foapu_Mutation
>;

export const useFoapuMissionQuotationMutation = () =>
  useGraphQLMutation(MissionQuotationPage_Quotation_Foapu_Mutation);
